// extracted by mini-css-extract-plugin
export default {"White":"#FFFFFF","Top":"10000","wrapper":"G734579","isExpanded":"G4099a2"};